import { render, staticRenderFns } from "./PickupDeliveryItem.vue?vue&type=template&id=5c5a5f50&scoped=true"
import script from "./PickupDeliveryItem.vue?vue&type=script&lang=js"
export * from "./PickupDeliveryItem.vue?vue&type=script&lang=js"
import style0 from "./PickupDeliveryItem.vue?vue&type=style&index=0&id=5c5a5f50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a5f50",
  null
  
)

export default component.exports